import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { OrderStatus } from "../../entities";

const redirectToDeviationCreate = (record, payload, history) => {
	if (!payload || !payload.status || !payload.id) {
		return false; //no payload or missing required fields
	}

	if (payload.status === OrderStatus.DEVIATION && record.status !== OrderStatus.DEVIATION) {
		const url = `/orders/${payload.id}/show/deviations/create`;
		history.push(url);
		return true; //successful redirect
	} else {
		return false;
	}
};

export const useGetRedirectToDeviationCreate = (record = {}) => {
	const history = useHistory();

	return useCallback(
		(payload) => {
			return redirectToDeviationCreate(record, payload, history);
		},
		[record, history]
	);
};
